<template>
  <f7-page class="main-new-farmer-page">
    <template #fixed>
      <TheNavbar
        nav-title="Nuevo Agricultor"
        back-btn-enable
        :style="appTheme"
      />
    </template>

    <div>
      <form @submit.prevent="addNewFarmer">
        <f7-block-title>Datos personales</f7-block-title>
        <f7-list>
          <f7-list-input
            v-if="code !== ''"
            :label="`${$t('common.code')}:`"
            type="text"
            :placeholder="`${$t('common.code')}:`"
            readonly
            clear-button
            :value="code"
            @input="code = $event.target.value"
          />
          <f7-list-input
            label="Nombre y apellidos"
            type="text"
            placeholder="Nombre y apellidos"
            required
            validate
            clear-button
            :value="name"
            @input="name = $event.target.value"
          />

          <f7-list-input
            label="DNI"
            type="text"
            placeholder="DNI"
            required
            validate
            clear-button
            :value="identifier"
            @input="identifier = $event.target.value"
          />

          <f7-list-item
            :title="$t('common.issuingCountry')"
            required
            validate
            smart-select
            :value="country"
            :smart-select-params="{
              closeOnSelect: true,
              searchbar: true,
              cssClass: 'new-farmer-smart-select',
            }"
          >
            <select
              name="emitCountry"
              @change="country = $event.target.value"
            >
              <option
                v-for="(f) in selectableCountries"
                :key="f.id"
                :value="f.id"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>

          <f7-list-input
            label="Teléfono"
            type="tel"
            placeholder="Teléfono"
            required
            validate
            clear-button
            :value="phone"
            @input="phone = $event.target.value"
          />
        </f7-list>

        <f7-block-title>
          {{ $t('common.address') }}
        </f7-block-title>
        <f7-list>
          <f7-list-input
            :label="$t('common.name')"
            type="text"
            :placeholder="$t('common.name')"
            required
            validate
            clear-button
            :value="address.name"
            @input="address.name = $event.target.value"
          />
          <f7-list-input
            label="Tipo Vía"
            type="select"
            placeholder="Tipo Vía"
            required
            validate
            clear-button
            default-value="CL"
            :value="address.type"
            @change="address.type = $event.target.value"
          >
            <option value="" />
            <option
              v-for="(value, key) in streetTypeOptions"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </f7-list-input>
          <f7-list-input
            label="Nombre vía"
            type="text"
            placeholder="Nombre vía"
            required
            validate
            clear-button
            :value="address.name2"
            @input="address.name2 = $event.target.value"
          />

          <f7-list-item
            :label="$t('common.country')"
            :title="$t('common.country')"
            smart-select
            :value="address.country"
            :smart-select-params="{
              closeOnSelect: true,
              searchbar: true,
              cssClass: 'new-farmer-smart-select',
            }"
          >
            <select
              name="addressCountry"
              @change="address.country = $event.target.value"
            >
              <option
                v-for="(f) in selectableCountries"
                :key="f.id"
                :value="f.id"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>
        </f7-list>
        <ComplementaryData
          class="padding-top"
          :entity="8"
          :dcs-data="dcData"
          @data-changed="complementaryDataChanged"
        />

        <f7-block>
          <f7-button
            type="submit"
          >
            {{ $t('common.save') }}
          </f7-button>
        </f7-block>
      </form>
    </div>
  </f7-page>
</template>

<script>
import FarmerService from '@/js/services/contracts/Farmers';
import MasterDataService from '@/js/services/contracts/MasterData';
import { StreetType } from '@/js/enums/erp';
import ComplementaryData from '@/components/contracts/ComplementaryData.vue';
import { LogError } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';
import TheNavbar from '@/components/TheNavbar.vue';

export default {
  name: 'NewFarmerPage',
  components: {
    TheNavbar,
    ComplementaryData,
  },

  data() {
    return {
      code: '',
      country: '',
      name: '',
      identifier: '',
      phone: '',
      address: {},
      dcData: {},
      selectableCountries: [],
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    newFarmer() {
      return {
        name: this.name,
        identifier: this.identifier,
        phone: this.phone,
        country: this.country,
        code: this.code,
        address: this.address,
        dcs: this.dcData,
      };
    },
    streetTypeOptions() {
      return StreetType;
    },
  },

  async mounted() {
    await this.loadCountries();
  },
  methods: {
    async addNewFarmer() {
      try {
        await FarmerService.add(this.newFarmer);
        f7.views.main.router.back();
      } catch (e) {
        LogError(this, this.addNewFarmer.name, e);
      }
    },
    complementaryDataChanged(newValue) {
      this.dcData = newValue;
    },
    async loadCountries() {
      const countries = await MasterDataService.getAllCountries();
      this.selectableCountries = countries;
    },
  },
};
</script>

<style scoped>
.new-farmer-smart-select {
  --f7-navbar-bg-color: var(--his-dark-blue);
}
</style>
